var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":"Pick Level"}},[_c('div',{staticClass:"d-flex mb-2",staticStyle:{"gap":"4px"}},_vm._l((_vm.levels),function(option,counter){return _c('span',{key:counter,staticStyle:{"flex":"1"}},[_c('button',{staticClass:"btn radio-btn",style:({
                width: '100%',
                background: _vm.selectedLevel === option ? _vm.selectedLevel.color : '#f8f9fa',
                border: `1px solid ${option.color}`,
                color: _vm.selectedLevel === option ? '#fff' : option.color
            }),attrs:{"type":"button"},on:{"click":function($event){_vm.selectedLevel = option; _vm.$emit('selectLevel', option.id)}}},[_vm._v(" "+_vm._s(option.name)+" ")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }